<template>
  <div
    class="ticon-workpackage-component"
    :style="`
      width: ${icon_size}px;
      height: ${icon_size}px;
      background-color: ${getColor(workpackage.color)};
    `"
  >
    <TIcon :name="workpackage.icon" :size="icon_size - 4" :color="getColor(workpackage.textcolor)" />
  </div>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import TIcon from '@/components/Taktify/TIcon.component.vue';

  export default {
    props: [
      'workpackage', // workpackage obj
      'size', // size in px
    ],

    mixins: [
      TColor
    ],
    components: {
      TIcon,
    },
    data: () => ({
    }),

    computed: {
      icon_size() {
        if(this.size) {
          return this.size;
        }
        return 24;
      },
    },
  }
</script>

<style>
.ticon-workpackage-component {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
</style>
